import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button, Radio, Glyphicon, PanelGroup, Panel } from 'react-bootstrap';
import { getYearOptions } from './../services/dateServices'
import Api from './../../../Global/Modules/Api'

const FETCH_URL = "api/workingexperiences/"

class WerkervaringToevoegen extends Component {
    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            data: {
                referenceId: '',
                levelId: '',
                company: '',
                customer: '',
                projectType: 0,
                project: '',
                city: '',
                yearInit: '',
                yearEnd: '',
                hours: '',
                projectDescription: '',
                jobDescription: '',
            },
            errors: {},
            references: [],
            levels: []
        }
    }
    componentWillMount() {
        Api.GetApi("api/references/?PageSize=101").then(data => {
            if (data !== undefined) {
                let references = data.references.map((ref, index) => {
                    return (<option value={ref.id}>{ref.firstName + ' ' + ref.middleName + ' ' + ref.lastName}</option>)
                })
                let levels = "";
                if (data.levels != null) {
                    levels = data.levels.map((ref, index) => {
                        return (<option value={ref.id}>{ref.code}</option>)
                    })
                }
                this.setState({ references: references })
                this.setState({ levels: levels })
            }
        })
    }
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ data: { ...this.state.data, [name]: value } })
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()

        var formData = new FormData()
        Object.keys(this.state.data).forEach(e => {
            formData.append(e, this.state.data[e])
        })

        const file = this.fileInput.files[0]
        formData.append('file', file === undefined ? null : file)

        Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
            .then(response => {
                alert("Werkervaring updated")
                window.location.reload();
            })
    }

    render() {
        let errors = this.state.errors
        return (
            <div>
                <PanelGroup accordion id="KennisToevoegen">
                    <Panel eventKey="1">
                        <Panel.Heading>
                            <Panel.Title toggle><Glyphicon glyph="plus" />{' '}Werkervaring toevoegen</Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible>
                            <Form horizontal onSubmit={this.handleSubmit}>
                                <FormGroup controlId="WerkervaringToevoegenReferentie">
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Referentie *
                                </Col>
                                    <Col sm={6}>
                                        <FormControl name="referenceId" value={this.state.data.referenceId} componentClass="select" required onChange={this.handleChange}>
                                            <option value="">selecteren</option>
                                            {this.state.references}
                                        </FormControl>
                                        {Api.showError(errors, "referenceId")}
                                    </Col>
                                </FormGroup>

                                <FormGroup controlId="WerkervaringToevoegenNiveau">
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Niveau *
                                </Col>
                                    <Col sm={6}>
                                        <FormControl name="levelId" value={this.state.data.levelId} componentClass="select" required onChange={this.handleChange}>
                                            <option value="">selecteren</option>
                                            {this.state.levels}
                                        </FormControl>
                                        {Api.showError(errors, "levelId")}
                                    </Col>
                                </FormGroup>

                                <FormGroup controlId="WerkervaringToevoegenWerkgever">
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Werkgever *
                                </Col>
                                    <Col sm={6}>
                                        <FormControl name="company" value={this.state.data.company} type="text" required onChange={this.handleChange} />
                                        {Api.showError(errors, "company")}
                                    </Col>
                                </FormGroup>

                                <FormGroup controlId="WerkervaringToevoegenOpdrachtgever">
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Opdrachtgever
                                </Col>
                                    <Col sm={6}>
                                        <FormControl name="customer" value={this.state.data.customer} type="text" onChange={this.handleChange} />
                                        {Api.showError(errors, "customer")}
                                    </Col>
                                </FormGroup>

                                <FormGroup controlId="WerkervaringToevoegenSoort">
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Soort project *
                                </Col>
                                    <Col sm={6}>
                                        <FormControl name="projectType" value={this.state.data.projectType} componentClass="select" required onChange={this.handleChange}>
                                            <option value="0">project</option>
                                            <option value="1">geclusterde</option>
                                        </FormControl>
                                        {Api.showError(errors, "projectType")}
                                    </Col>
                                </FormGroup>

                                <FormGroup controlId="WerkervaringToevoegenProject">
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Project
                                </Col>
                                    <Col sm={6}>
                                        <FormControl name="project" value={this.state.data.project} type="text" onChange={this.handleChange} />
                                        {Api.showError(errors, "project")}
                                    </Col>
                                </FormGroup>

                                <FormGroup controlId="WerkervaringToevoegenLocatie">
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Locatie
                                </Col>
                                    <Col sm={6}>
                                        <FormControl name="city" value={this.state.data.city} type="text" onChange={this.handleChange} />
                                        {Api.showError(errors, "city")}
                                    </Col>
                                </FormGroup>

                                <FormGroup controlId="WerkervaringToevoegenJaarVan">
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Jaar van *
                                </Col>
                                    <Col sm={6}>
                                        <FormControl name="yearInit" value={this.state.data.yearInit} componentClass="select" required onChange={this.handleChange}>
                                            <option value="">selecteren</option>
                                            {getYearOptions()}
                                        </FormControl>
                                        {Api.showError(errors, "yearInit")}
                                    </Col>
                                </FormGroup>

                                <FormGroup controlId="WerkervaringToevoegenJaarTot">
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Jaar tot *
                                </Col>
                                    <Col sm={6}>
                                        <FormControl name="yearEnd" value={this.state.data.yearEnd} componentClass="select" required onChange={this.handleChange}>
                                            <option value="">selecteren</option>
                                            {getYearOptions()}
                                        </FormControl>
                                        {Api.showError(errors, "yearEnd")}
                                    </Col>
                                </FormGroup>

                                <FormGroup controlId="WerkervaringToevoegenUren">
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Uren *
                                </Col>
                                    <Col sm={6}>
                                        <FormControl name="hours" value={this.state.data.hours} type="text" required onChange={this.handleChange} />
                                        {Api.showError(errors, "hours")}
                                    </Col>
                                </FormGroup>

                                <FormGroup controlId="WerkervaringToevoegenOmschrijvingProject">
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Omschrijving project *
                                </Col>
                                    <Col sm={6}>
                                        <FormControl name="projectDescription" value={this.state.data.projectDescription} componentClass="textarea" rows="5" required onChange={this.handleChange} />
                                        {Api.showError(errors, "projectDescription")}
                                    </Col>
                                </FormGroup>

                                <FormGroup controlId="WerkervaringToevoegenOmschrijvingWerkzaamheden">
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Omschrijving werkzaamheden *
                                </Col>
                                    <Col sm={6}>
                                        <FormControl name="jobDescription" value={this.state.data.jobDescription} componentClass="textarea" rows="5" required onChange={this.handleChange} />
                                        {Api.showError(errors, "jobDescription")}
                                    </Col>
                                </FormGroup>

                                <FormGroup controlId="WerkervaringToevoegenDocument">
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Document toevoegen
                                    </Col>
                                    <Col sm={6}>
                                        <FormControl type="File" inputRef={input => this.fileInput = input} />
                                        {Api.showError(errors, "file")}
                                    </Col>
                                </FormGroup>

                                <FormGroup>
                                    <Col smOffset={8} sm={2}>
                                        <Button type="submit">Toevoegen</Button>
                                        {Api.showError(errors, "generalError")}
                                    </Col>
                                </FormGroup>
                            </Form>
                        </Panel.Body>
                    </Panel>
                </PanelGroup>
            </div>
        );
    }
}

export default WerkervaringToevoegen;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Werkervaring/WerkervaringToevoegen.js